import { VueModule } from '@Foundation';
import BazaarvoiceTagging from './code/Scripts/components/bazaarvoicetagging';

export default VueModule({
  components: {
    BazaarvoiceTagging
  }
});
